import {
	FabIcons,
	FadIcons,
	FajdIcons,
	FajfIcons,
	FajrIcons,
	FarIcons,
	FasIcons,
	FawsbIcons,
	Library,
} from '@playbooks/icons';

Library({
	...FabIcons,
	...FadIcons,
	...FajdIcons,
	...FajfIcons,
	...FajrIcons,
	...FasIcons,
	...FarIcons,
	...FasIcons,
	...FawsbIcons,
});
